import React, { useRef } from 'react';
import styled, { css } from 'styled-components';

import { ContentWrapper, VerticalDivider } from 'components/core';
import { CartButton } from 'components/cart';
import { AddressTextButton } from 'components/location-settings-popover';
import { LocationSettingsControllerDark } from 'src/components/location-settings-popover/location-settings-controller-dark';
import MyAccountLink from './my-account-link';
import { HeaderLogo } from './header-logo';

const GlobalHeaderDesktopDark = ({
  cartButtonRef,
  globalHeaderRef,
  address,
  orderType,
  href,
  route,
  itemCount,
  isDispensaryList,
  toggleCartView,
  onSaveLocationSettings,
  onAddressTextButtonClick,
}) => {
  const locationAnchorRef = useRef(null);

  return (
    <Wrapper id='global-header' ref={globalHeaderRef} $isDispensaryList={isDispensaryList}>
      <ContentWrapper bg='var(--rds-plum)' flexGrow={0} maxWidth={1400}>
        <Container>
          <HeaderLogo href={href} route={route} isDark />

          <ContentGroup>
            <HeaderDivider mx='30px' />
            <DropdownContainer ref={locationAnchorRef} data-testid='dropdown-web'>
              <AddressTextButton onClick={onAddressTextButtonClick} address={address} orderType={orderType} />
              <LocationSettingsControllerDark onSave={onSaveLocationSettings} anchorEl={locationAnchorRef} />
            </DropdownContainer>
          </ContentGroup>

          <ContentGroup>
            <HeaderDivider mx='23px' />
            <DropdownContainer>
              <MyAccountLink />
            </DropdownContainer>

            <DropdownContainer>
              <DarkCartButton
                ref={cartButtonRef}
                onClick={toggleCartView}
                variant='darkBlue'
                itemCount={itemCount}
                showCountColor
              />
            </DropdownContainer>
          </ContentGroup>
        </Container>
      </ContentWrapper>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  box-shadow: 0px 3px 2px rgba(0, 0, 0, 0.15);
  width: 100%;
  z-index: 1200;

  .content-wrapper {
    max-width: 1536px;
  }

  ${({ isDispensaryList }) =>
    isDispensaryList &&
    css`
      position: fixed;
      width: 100%;
    `}
`;

const Container = styled.header`
  position: relative;
  z-index: 100;
  background-color: var(--rds-plum);
  display: flex;
  height: 70px;
  align-items: center;
  padding-left: 34px;
  padding-right: 24px;
  div:nth-child(2) {
    flex: 1;
  }
`;

const ContentGroup = styled.div`
  display: flex;
  align-items: center;
`;

const HeaderDivider = styled(VerticalDivider)`
  border-color: var(--rds-divider);
  height: 34px;
  margin-bottom: 1px;
`;

const DropdownContainer = styled.div`
  align-items: center;
  position: relative;
`;

const DarkCartButton = styled(CartButton)`
  &&& {
    background-color: var(--rds-divider);
  }
`;

export default GlobalHeaderDesktopDark;
